import Link from 'next/link';

import { SButton } from './styled';

export interface IProps {
    btnText?: string,
    btnLink: string,
    className?: string,
}

const Button = ({ btnText = 'Подробнее', btnLink, className }: IProps): JSX.Element => {
    return (
        <Link
            href={btnLink}
            prefetch={false}
            passHref
        >
            <SButton className={className} data-test='subitem-btn'>{btnText}</SButton>
        </Link>
    );
};

export default Button;
